$('.annnouncement-text').slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  cssEase: 'ease-in-out'
});

$('.collections-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  loop: false,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300,
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    },
    {
      breakpoint: 375,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.header-reviews-slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  loop: false,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      },
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$('.heroes-slider').slick({
  infinite: true,
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  loop: false,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300
});
document.addEventListener('StartAsyncLoading',function(event){
$('.reviews-slider').slick({
 fade: true,
  cssEase: 'linear',
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  prevArrow:"<img class='a-left control-c prev slick-prev' src='https://uploads-ssl.webflow.com/6307a1df88a6bdf191effef2/6307ec17b6064f301fba16ba_prev.svg'>",
  nextArrow:"<img class='a-right control-c next slick-next' src='https://uploads-ssl.webflow.com/6307a1df88a6bdf191effef2/6307ec173982ecedf0f76a7f_next.svg'>",
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 560,
      settings: {
      arrows: false,
      dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
 
$('.r-posts-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  loop: false,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}); 
  
var lastIdx = -1;
$('.review-item-box2').on('mouseover', function(){
	if(lastIdx == $(this).index())
    return;
  lastIdx = $(this).index();
	let image = $(this).find('.review-item-img')[0].src;
  let volumeName = $(this).find('.volume-marquee__volume-name')[0].innerText;
  let volumeNumber = $(this).find('.volume-marquee__volume-number')[0].innerText;
  let backgroundColor = $(this).find('.volume-marquee__volume-color').first().css('backgroundColor');
  $('.review-item-img').first().fadeOut(100, function() {
  	$(this).attr('src', image).fadeIn(100);
  });
  $('.volume-preview__volume-name').first().fadeOut(100, function() {
  	$(this).text(volumeName).fadeIn(100);
  });
  $('.volume-preview__volume-number').first().fadeOut(100, function() {
  	$(this).text(volumeNumber).fadeIn(100);
  });
  $('.volume-preview__background').first().css('backgroundColor', backgroundColor);
});
$('.product-slider').slick({
      autoplay: false,
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: false,
      dots: false,
      asNavFor: '.product-slider-thumbnail'
    });
    $('.product-slider-thumbnail').slick({
      autoplay: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.product-slider',
       vertical: false,
      dots: false,
      arrows: false,
      focusOnSelect: true,
      variableWidth: false,
       responsive: [
        {
        breakpoint: 1000,
        settings: {  
          vertical:true,
          slidesToShow: 3.5,
          slidesToScroll: 1
           }
        },    
        {
        breakpoint: 480,
        settings: {
           vertical:true,
          slidesToShow: 3.5,
          slidesToScroll: 1
           }
        }
      ]
    });

document.addEventListener('StartAsyncLoading',function(event){
$('.following-slider').slick({
  dots: true,
  arrows: false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$('.competitor-slider').slick({
  dots: false,
  arrows: false,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
}); 
$(document).ready(function() {
  var variant_Id = $(".bundle-radio-field.w-radio.bundle-active").attr('variant-id');
 $(".bundle-radio-field.w-radio").siblings(".atc_action_button").find(".hidden_varinat_id_value").val(variant_Id);
  
    $('label.bundle-radio-field').click(function() {
        $('label.bundle-radio-field').removeClass('bundle-active');
        $(this).addClass('bundle-active');
    });
    $( ".bundle-radio-field.w-radio" ).click(function() {
      var variant_Id = $(".bundle-radio-field.w-radio.bundle-active").attr('variant-id');
      $(this).siblings(".atc_action_button").find(".hidden_varinat_id_value").val(variant_Id);
    });
});

    var Total_item = $("li.related-item").length, // Total number of raltaed item to choose from
        item_toshow = 3, // total items to show in your cart page
        array = [], // array with index number of all available items
        shuffle = [], // array with shuffled index number
        rnd;
    
    for (i = 0; i < Total_item; i++) {
      array[i] = i;
    }
    
    for (i = 0; i < Total_item; i++) { // pick numbers
      rnd = Math.floor(Math.random() * array.length); 
      shuffle[i] = array.splice(rnd,1)[0]; // remove the selected number from the array and get it in another variable
    }
    
    for (i = 0; i < item_toshow; i++){
        $("li.related-item").slice(shuffle[i],shuffle[i]+1).show();
    }


// progress bar
  window.addEventListener("DOMContentLoaded", () => {
  // update circle when range change
  const pie = document.querySelectorAll(".pie");
  const range = document.querySelector('[type="range"]');

  range.addEventListener("input", (e) => {
    pie.forEach((el, index) => {
      const options = {
        index: index + 1,
        percent: e.target.value
      };
      circle.animationTo(options);
    });
  });

  // start the animation when the element is in the page view
  const elements = [].slice.call(document.querySelectorAll(".pie"));
  const circle = new CircularProgressBar("pie");

  // circle.initial();

  if ("IntersectionObserver" in window) {
    const config = {
      root: null,
      rootMargin: "0px",
      threshold: 0.75
    };

    const ovserver = new IntersectionObserver((entries, observer) => {
      entries.map((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.75) {
          circle.initial(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, config);

    elements.map((item) => {
      ovserver.observe(item);
    });
  } else {
    elements.map((element) => {
      circle.initial(element);
    });
  }

  setInterval(() => {
    const typeFont = [100, 200, 300, 400, 500, 600, 700];
    const colorHex = `#${Math.floor((Math.random() * 0xffffff) << 0).toString(
      16
    )}`;
    const options = {
      index: 17,
      percent: Math.floor(Math.random() * 100 + 1),
      colorSlice: colorHex,
      fontColor: colorHex,
      fontSize: `${Math.floor(Math.random() * (1.4 - 1 + 1) + 1)}rem`,
      fontWeight: typeFont[Math.floor(Math.random() * typeFont.length)]
    };
    circle.animationTo(options);
  }, 3000);

  // global configuration
  const globalConfig = {
    speed: 30,
    animationSmooth: "1s ease-out",
    strokeBottom: 5,
    colorSlice: "#FF6D00",
    colorCircle: "#f1f1f1",
    round: true
  };

  const global = new CircularProgressBar("global", globalConfig);
  global.initial();

  // update global example when change range
  const pieGlobal = document.querySelectorAll(".global");
  range.addEventListener("input", (e) => {
    pieGlobal.forEach((el, index) => {
      const options = {
        index: index + 1,
        percent: e.target.value
      };
      global.animationTo(options);
    });
  });

  document.querySelectorAll("pre code").forEach((el) => {
    hljs.highlightElement(el);
  });

  const infoCode = document.querySelectorAll(".info-code");
  infoCode.forEach((info) => {
    info.addEventListener("click", (e) => {
      e.target.closest("section").classList.toggle("show-code");
    });
  });
});

// currentPopup code
$(document).ready(function () {
  var a = {
    el: {},
    data: { currentPopup: [] },
    init: function (e) {
      var t = this;
      t.bindUIActions(),
        e && (t.data.settings = e),
        window.location.hash && t.open(window.location.hash.replace("#", ""));
    },
    bindUIActions: function () {
      var e = this;
      $(document).on("click", "[data-popup]", function () {
        $(this).data("popup")
          ? ($(this).data("type") == "image-popup"
              ? $("#popup_img_id").attr("src", $(this).data("src"))
              : $("#video_path").attr("src", $(this).data("src")),
            e.open($(this).data("popup")))
          : alert("Please provide popup Id.");
      }),
        $(document).on("click", ".popup__close", function (t) {
          var o = $(t.delegateTarget).find("iframe"),
            n = o.attr("src");
          o.attr("src", "/empty.html"),
            o.attr("src", ""),
            $("#popup_img_id").attr("src", ""),
            $("#video_path").attr("src", ""),
            e.close($(this).parents(".popup").attr("id"));
        }),
        $(document).mouseup(function (t) {
          if (e.data.currentPopup.length > 0) {
            var o = $(".popup__wrap");
            if (!o.is(t.target) && o.has(t.target).length === 0) {
              var n = $(t.delegateTarget).find("iframe"),
                r = n.attr("src");
              n.attr("src", "/empty.html"), n.attr("src", r), e.close();
            }
          }
        }),
        $(document).keyup(function (t) {
          e.data.currentPopup.length > 0 && t.keyCode == 27 && e.close();
        });
    },
    open: function (e) {
      var t = this,
        o = $("#" + e);
      o.length > 0 &&
        (t.data.currentPopup.push(e),
        o.css("z-index", 99 + t.data.currentPopup.length).addClass("open"),
        o.find(".popup_focus").focus(),
        $("body").addClass("popup__is-open"),
        t.data.settings &&
          t.data.settings.afterOpen &&
          t.data.settings.afterOpen(e));
    },
    close: function (e) {
      var t = this;
      e || (e = t.data.currentPopup[t.data.currentPopup.length - 1]);
      var o = $("#" + e);
      if (o.length > 0) {
        var n = t.data.currentPopup.indexOf(e);
        t.data.currentPopup.splice(n, 1),
          o.removeClass("open"),
          $("body").removeClass("popup__is-open"),
          t.data.settings &&
            t.data.settings.afterClose &&
            t.data.settings.afterClose(e);
      } else alert("Popup Not Found!");
    },
  };
  $(document).ready(function () {
    a.init(), $(".afterpay-paragraph").insertAfter(".product-form");
  });
  function s() {
    for (
      var e = document.getElementsByTagName("iframe"), t = 0;
      t < e.length;
      t++
    )
      e[t].getAttribute("data-src") &&
        e[t].setAttribute("src", e[t].getAttribute("data-src"));
  }
    (window.onload = s);
});


// order page js
$('.header-reviews-slider').slick({
  dots: true,
  arrows: false,
  infinite: false,
  loop: false,
  autoplay: true,
  autoplaySpeed: 1500,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});

$(document).ready(function () {
  var v_id= $('.bundle-field.order-checkout-bundle.bundle-active').attr('variant_id');
  $('.product-select-content-row').attr("b_product_id",v_id);
});

